import { render, staticRenderFns } from "./CardDocuments.vue?vue&type=template&id=130221cc&scoped=true&"
import script from "./CardDocuments.vue?vue&type=script&lang=js&"
export * from "./CardDocuments.vue?vue&type=script&lang=js&"
import style0 from "./CardDocuments.vue?vue&type=style&index=0&id=130221cc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "130221cc",
  null
  
)

export default component.exports